<button
  mat-button
  [class]="classes()"
  [color]="color()"
  [type]="type()"
  [disabled]="disabled()"
  (click)="buttonClick.emit($event)">
  <ng-content />
</button>
